import styled from 'styled-components';

import { spacing, colors, fontWeights, body2Bold } from 'ui/theme';
import { UnarchivableItemDisplayText, UnarchivableItem } from '../types';

const BulkUnarchiveDetailsList = styled.ul`
  ${body2Bold}
  display: flex;
  flex-direction: column;
  gap: ${spacing.quarter};
  padding: ${spacing.base};
  border-radius: ${spacing.quarter};
  background: ${colors.backgroundSecondary};
  border: 1px solid ${colors.borderPrimary};
  max-height: ${spacing.x24};
  overflow-y: auto;

  li {
    list-style: none;
  }
`;

const BoldText = styled.b`
  font-weight: ${fontWeights.bold};
`;

type BulkUnarchivePromptProps = {
  displayTextForContentItems: UnarchivableItemDisplayText;
  content: UnarchivableItem[];
};

export const BulkUnarchivePrompt = ({
  content,
  displayTextForContentItems,
}: BulkUnarchivePromptProps) => (
  <>
    <p>
      Are you sure that you want to unarchive these{' '}
      <BoldText>
        {content.length} {displayTextForContentItems.itemTypeName.plural}
      </BoldText>
      ?
    </p>
    <BulkUnarchiveDetailsList>
      {content.map((item) => (
        <li key={item.id}>{item.name}</li>
      ))}
    </BulkUnarchiveDetailsList>
  </>
);
